import { Color, LeaseCarDataService, Option, Upgrade } from 'types';

import {
	ChosenLeaseCarActionTypes,
	RESET_CHOSENLEASECAR,
	SET_CHECKOUT_BEGINS,
	SET_COLOR,
	SET_DURATION,
	SET_KILOMETRAGE,
	SET_OPTIONS_AND_ACCESSOIRES,
	SET_PAYMENT_IN_ADVANCE_AMOUNT,
	SET_PAYMENT_IN_ADVANCE_CHOICE,
	SET_PRICE_POINT_ID,
	SET_PRICE_POINT_PRICE,
	SET_SERVICES,
	SET_TOTAL_PRICE,
	SET_UPGRADE,
} from './chosenLeaseCarActionTypes';

export const setOptionsAndAccessoires = (payload: Option[]): ChosenLeaseCarActionTypes => ({
	type: SET_OPTIONS_AND_ACCESSOIRES,
	payload,
});

export const setServices = (payload: LeaseCarDataService[]): ChosenLeaseCarActionTypes => ({
	type: SET_SERVICES,
	payload,
});

export const setUpgrade = (payload: Upgrade): ChosenLeaseCarActionTypes => ({
	type: SET_UPGRADE,
	payload,
});

export const setDurationPeriod = (payload: string): ChosenLeaseCarActionTypes => ({
	type: SET_DURATION,
	payload,
});

export const setKilometrageChoice = (payload: string): ChosenLeaseCarActionTypes => ({
	type: SET_KILOMETRAGE,
	payload,
});

export const setIdForPricePoint = (payload: number): ChosenLeaseCarActionTypes => ({
	type: SET_PRICE_POINT_ID,
	payload,
});

export const setPriceForPricePoint = (payload: number): ChosenLeaseCarActionTypes => ({
	type: SET_PRICE_POINT_PRICE,
	payload,
});

export const setChosenLeaseCarTotalPrice = (payload: number): ChosenLeaseCarActionTypes => ({
	type: SET_TOTAL_PRICE,
	payload,
});

export const setChosenLeaseCarColor = (payload: Color): ChosenLeaseCarActionTypes => ({
	type: SET_COLOR,
	payload,
});

export const setCheckoutBegins = (payload: boolean): ChosenLeaseCarActionTypes => ({
	type: SET_CHECKOUT_BEGINS,
	payload,
});

export const setPaymentInAdvanceChoice = (payload: boolean): ChosenLeaseCarActionTypes => ({
	type: SET_PAYMENT_IN_ADVANCE_CHOICE,
	payload,
});

export const setPaymentInAdvanceAmount = (
	payload: number | undefined
): ChosenLeaseCarActionTypes => ({
	type: SET_PAYMENT_IN_ADVANCE_AMOUNT,
	payload,
});

export const resetChosenLeaseCar = (): ChosenLeaseCarActionTypes => ({
	type: RESET_CHOSENLEASECAR,
});

export const setDuration = (duration: string) => ({
	type: SET_DURATION,
	payload: duration,
});
